/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Category } from './category';
import { EnumDto } from './enumDto';
import { Industry } from './industry';

export interface UtilityDataDto { 
    channels?: Array<EnumDto>;
    categories?: Array<Category>;
    industries?: Array<Industry>;
    subscriptionTypes?: Array<EnumDto>;
    servicePeriodTypes?: Array<EnumDto>;
    serviceStatusTypes?: Array<EnumDto>;
    billBasisTypes?: Array<EnumDto>;
}